import { Grid, useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp';
import EditCustomAPIConfigPopup from './customAPI/customAPIConfigPopup';
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext';
import { dataConnectorList } from '../../../../../models/axiosModel';
import { isSystemApi } from '../../../../../utils/constants';

function CustomAPICall(props: any) {

    const { actionData, stepAction } = props;
    const [flagWebhookPopup, setFlagWebhookPopup] = useState<boolean>(false);
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');


    const { nodes, setTempNodesTemplate } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    const [dataConnectorDetails, setDataConnectorDetails] = useState<dataConnectorList | null>(null);

    useEffect(() => {
        let currentDataConnector = currentActiveStaticWorkflow?.additional_data?.data_connectors?.find((connector: dataConnectorList) => connector.chatbot_data_connector_id == actionData?.data_connector?.chatbot_data_connector_id);
        if (currentDataConnector) {
            setDataConnectorDetails(currentDataConnector);
        }
    }, [actionData])

    return (
        <Grid item>
            <Grid container direction={"column"} gap={"12px"}>
                <Grid item mt={2} className={textStyles.templatesContainer}>
                    <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                        <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                            Custom API
                        </Grid>
                        <Grid item className={styles.contentBlockSubHeadingStyle} sx={{ '&:hover': { backgroundColor: "rgba(0,0,0,0.02)" }, padding: "2px 4px" }}>
                            <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                <Grid item sx={{ wordBreak: "break-word" }}>
                                    {actionData.data_connector.chatbot_data_connector_id ?
                                            !dataConnectorDetails?.function_method_name ? 
                                                `System API - ${dataConnectorDetails?.data_connector_functions?.data_connector_function_name}`
                                            :
                                            <a href={`${window.location.origin}/customAPI/createCustomAPI?connector_id=${actionData.data_connector.chatbot_data_connector_id}`} target='blank'>
                                                {`${dataConnectorDetails?.function_method_name} - ${dataConnectorDetails?.data_connector_functions?.data_connector_function_name}`}
                                            </a>
                                        :
                                        "Please select a Custom API"
                                    }
                                </Grid>
                                <Grid item>
                                    <ModeEditIcon sx={{ display: "flex", height: "16px", width: "16px", cursor: "pointer" }} onClick={() => { setFlagWebhookPopup(true); setTempNodesTemplate(nodes) }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {flagWebhookPopup &&
                <GlobalPopUp
                    open={flagWebhookPopup}
                    onClose={() => {
                        setFlagWebhookPopup(false);
                    }}
                    flagBackdrop
                    paperMinWidth={flagSmallScreen ? "280px" : "65%"}
                    paperMaxwidth={flagSmallScreen ? "580px" : "65%"}
                    flagShowCloseIcon={true}
                    titlePadding='0'
                    handleClose={() => {
                        setFlagWebhookPopup(false)
                    }}
                >
                    <EditCustomAPIConfigPopup actionData={actionData} stepAction={stepAction} setFlagWebhookPopup={setFlagWebhookPopup} />
                </GlobalPopUp>
            }
        </Grid>
    )
}

export default CustomAPICall